<div id="about">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Overview</h4>
                  <div class="card-body text-center">
                     <p class="inner-lead">Our school aims at introducing value-based quality education in students. I feel that every child is unique with latent qualities. Our teachers do their best to find those qualities and pave the way for him to develop himself into an impressive personality. Blended efforts of teachers and parents make the student never lose sight of his nurtured dream.</p>
                     <p class="inner-lead">Students also should get the advantage of this opportunity and use their skills to perfection to become 'winning personalities' and complete human beings.</p>
                     <p class="inner-lead">Ram Prasad DAV Public School is being run by Ram Parsad DAV Public School Society</p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>